<template>
  <Modal ref="modal" title="Confirmar agendamento" @cance="close">
    <div class="modal-container" v-if="loaded">
      <p>Confira os dados antes de dar continuidade com o agendamento!</p>

      <div v-if="data.consumirCreditos" class="credit-alert">
        <span class="alert-icon">⚠️</span>
        <p>Ao confirmar este agendamento, 1 crédito será debitado neste agendamento.</p>
      </div>

      <div class="inputs-row">
        <Input legend="Aluno" :modelValue="data.aluno || 'Carregando...'" readonly class="input-full" />

        <Input legend="CPF" :modelValue="data.cpf || 'Carregando...'" readonly class="input-full" />
      </div>

      <div class="inputs-row">
        <Input legend="Instrutor" :modelValue="data.instrutor.text || 'Carregando...'" readonly class="input-full" />

        <Input legend="Veículo" :modelValue="data.veiculo.text || 'Carregando...'" readonly class="input-full" />
      </div>

      <div class="horarios-container">
        <h3>Horários</h3>

        <div class="datas">
          <div class="data" v-for="(data, index) in data.datas" :key="index">
            <span>{{ utils.formatDate(data.data) }}</span>
            <span>{{ data.is_double ? 'Aula dupla' : 'Aula simples' }}</span>
          </div>
        </div>
      </div>

      <div class="buttons">
        <Button @handle:click="close" text="Cancelar" color="danger" />
        <Button @handle:click="() => onConfirm(data)" text="Confirmar" color="primary" />
      </div>
    </div>
  </Modal>
</template>

<script>
import Modal from 'core/Modal'
import Input from 'core/Input'
import Button from 'core/Button'
import utils from '../../services/utils'

export default {
  name: 'ConfirmScheduleModal',
  components: {
    Modal,
    Input,
    Button,
  },
  props: {
    onConfirm: Function,
  },
  data() {
    return {
      utils: utils,
      data: '',
      loaded: false,
    }
  },
  methods: {
    open(data) {
      this.data = data

      if (this.data) {
        this.loaded = true
        this.$refs.modal.open()
      }
    },
    close() {
      this.data = ''
      this.loaded = false
      this.$refs.modal.close()
    },
  }
}
</script>

<style lang="scss" scoped>
.modal-container {
  width: 70vw;
  display: flex;
  flex-direction: column;
  gap: 1rem;

  .inputs-row {
    display: flex;
    align-items: center;
    gap: 0.5rem;

    .input-full {
      flex: 1;
    }
  }

  .horarios-container {
    display: flex;
    flex-direction: column;
    gap: 0.5rem;

    h3 {
      margin: 0;
      font-size: 1rem;
      font-weight: 600;
      line-height: 21.82px;
      color: #606264;
    }

    .datas {
      display: flex;
      flex-wrap: wrap;
      gap: 1.5rem;

      .data {
        padding: 1rem;
        background: #F1F1F1;
        border-radius: 8px;

        display: flex;
        flex-direction: column;
        gap: 1rem;

        >span {
          font-size: 1rem;
          font-weight: 600;
          color: #202224;
        }

        .horarios-card {
          display: grid;
          grid-template-columns: 1fr 1fr;
          column-gap: 1rem;

          .categoria {
            display: flex;
            flex-direction: column;
            gap: 1rem;

            >span {
              font-size: 0.875rem;
              font-weight: 500;
              color: #000000;
            }

            .horarios {
              display: flex;
              flex-direction: column;
              gap: 0.5rem;

              >span {
                text-align: center;
              }
            }
          }
        }
      }
    }
  }

  .buttons {
    align-self: flex-end;
    display: flex;
    align-items: center;
    gap: 1rem;
  }

  .credit-alert {
    display: flex;
    align-items: center;
    gap: 0.75rem;
    padding: 1rem;
    background: #FFF4E5;
    border: 1px solid #FFB020;
    border-radius: 8px;

    .alert-icon {
      font-size: 1.5rem;
      line-height: 1;
    }

    p {
      margin: 0;
      font-size: 0.875rem;
      font-weight: 500;
      color: #663C00;
      line-height: 1.4;
    }
  }
}
</style>